export const OPEN_QUICK_OPEN_EVENT = "izanagi:open-quick-open";

export interface QuickOpenEventDetail {
	query?: string;
}

/** クイックオープンのパレットを開く。`query` を渡すと、その文字列を入力した状態で開く。 */
export function openQuickOpen(query?: string): void {
	window.dispatchEvent(
		new CustomEvent<QuickOpenEventDetail>(OPEN_QUICK_OPEN_EVENT, { detail: { query } }),
	);
}
